import { from, Subject } from 'rxjs';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, Input} from '@angular/core';
import { APIService } from '../../api.service';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../services/data.service';


@Component({
  selector: 'app-stage-config',
  templateUrl: './stage-config.component.html',
  styleUrls: ['./stage-config.component.scss']
})
export class StageConfigComponent implements OnInit {
  @Input() mdlRef: any;
    stagemodalshow:boolean = false
    Stages: any = [];
    StagesData: any = [];
    agencyData: any = [];
    jarvisData: any = []; 
    userData: any = [];
    editRights: any  = [];
    rights: any = [];
    UIDs : any = [];
    isEdit: boolean = false;
    editStageId: number = 0;
    Seq: number = 0;
    dropedId: number = 0;
    stage: string = ""
    newStage = {
        stageName: ''
    }
    prTypeID: number = 1;
    allStagesList: any = [];
    finalStages: any = [];


  
    drop(event: CdkDragDrop<string[]>) {
      moveItemInArray(this.Stages, event.previousIndex, event.currentIndex);
      for(let j = 0; j < this.Stages.length; j++){
        this.Stages[j].Seq = j + 1;
      }
      this.save()
    }
  constructor(private modalService: NgbModal, private apiService: APIService, private router: Router, private dataSer: DataService,) { }

    ngOnInit(): void {
      // this.dataSer.projectData.subscribe((value: any) => {
      //   debugger
      //   if(value.prTypeID != '' && value.prTypeID != undefined){
      //     this.prTypeID = value.prTypeID;
      //   }
      // });
      let selectPrID = this.apiService.getCookie("prTypeID");
      if(selectPrID == '2'){
        this.prTypeID = 2
      }

      if(this.mdlRef){
        this.stagemodalshow = true;
        }
     
        let agencyData = this.apiService.getCookie("M");
        if (agencyData) {
          this.agencyData = JSON.parse(agencyData);
        }
        var jarvis = this.apiService.getCookie("Jarvis");
        if (jarvis) {
          this.jarvisData = JSON.parse(jarvis);
        }
        var user = this.apiService.getCookie("J");
        if (user) {
        this.userData = JSON.parse(user);
        }
        this.getRigths()
        this.getStage()
       
    }


    //getRigths() - get all users
  getRigths(){
    this.rights = [];
    for(let i = 0; i < this.userData.length; i++){
      if(this.jarvisData[0].UserID == this.userData[i].UserID || this.userData[i].UserID == this.agencyData[0].AdminUserID){     
        let temp = {
          UserID : this.userData[i].UserID,
          Name: this.userData[i].Name,
          isChecked:true,
          IsDisabled:true
        }
        this.rights.push(temp);
      }
      else{
        let temp = {
          UserID : this.userData[i].UserID,
          Name: this.userData[i].Name,
          isChecked:false,
          IsDisabled:false
        }
        this.rights.push(temp);
      } 
    }
    this.rights.sort((a:any,b:any) => a.Name.localeCompare(b.Name));
  }

     // getUnits() - get all units from database
   getStage(){
    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'getConfig',
        moduleID: 6,
        data: ''
    }];
    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
    }
  
    //successResp - success  get handler
    successResp(res: any) {
      debugger
      if (res.error) {
      }
      else {
          if (res) {
            debugger
              var reponseData = JSON.parse(res.updatePackage);
              if (reponseData.Table2) {
                  this.Stages = [];
                  let editDataArry = JSON.parse(reponseData.Table2[0].PrdJobStages);
                  for(let j = 0; j < editDataArry.length; j++){
                    let TempUIDs : any = [];
                    let IDs = editDataArry[j].UIDs == undefined ? '' : (editDataArry[j].UIDs).split(",")
                    if(IDs != ''){
                      for(let i = 0; i < IDs.length; i++){
                        var IDsData = this.userData.filter(function (element: any, index: any) {
                          return (element.UserID == IDs[i]);
                      });
                      if(IDsData.length > 0){
                        let temp = {
                          UserID : IDs[i],
                          Name : IDsData[0].Name
                        }
                        TempUIDs.push(temp)
                      }
                    }
                    }
                    
                    this.Stages.push({
                      'SID': editDataArry[j].SID,
                      'SNm': editDataArry[j].SNm,
                      'Seq': editDataArry[j].Seq,
                      'UIDs': TempUIDs.length == 0 ? [] : TempUIDs,
                      'TID': editDataArry[j].TID ? editDataArry[j].TID : 1,
                  });
                  }

                  //this.allStagesList = this.Stages;
                  let productionStages = this.Stages.filter((x: any) => x.TID == 1)
                  if(this.prTypeID == 1 && productionStages.length > 0){
                    this.finalStages = productionStages;
                  }
                  let projectStages = this.Stages.filter((x: any) => x.TID == 2)
                  if(this.prTypeID == 2 &&  projectStages.length > 0){
                    this.finalStages = projectStages;
                  }
              }
          }
      }
      this.Stages.sort(function(a:any,b:any) {
        return a.Seq - b.Seq;
      });
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
  }

  closeResult: any;
  modalReference: any;

  open(content: any, id: number) {
      this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'addStageMdl' });
      this.modalReference.result.then((result: any) => {
          this.closeResult = `Closed with: ${result}`;
      },
          (reason: any) => {
              this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          });

      if (id == 0) {
        this.newStage.stageName = ""
      }
      else{
        this.editStageId = id;
        var StageData = this.Stages.filter(function (element: any, index: any) {
            return (element.SID == id);
        });
        this.isEdit = true;
        const stageOld:string = StageData[0].SNm;
        this.stage = stageOld;
        this.Seq = StageData[0].Seq;
        this.editRights = []
        let storeUserLength = StageData[0].UIDs == undefined ? 0  : StageData[0].UIDs.length;
        for(let j = 0; j < this.rights.length; j++){   
            if(storeUserLength > 0){
              let storeUser = StageData[0].UIDs.filter((x: any) => x.UserID == this.rights[j].UserID);
              let temp: any = {};
                if(storeUser.length > 0){
                    temp = {
                      UserID:this.rights[j].UserID,
                      Name: this.rights[j].Name,
                      isChecked:true,
                      IsDisabled:this.rights[j].IsDisabled
                    }
                }
                else{
                  temp = {
                    UserID:this.rights[j].UserID,
                    Name: this.rights[j].Name,
                    isChecked:false,
                    IsDisabled:this.rights[j].IsDisabled
                  }
                }
              this.editRights.push(temp);
            }
            else{
              this.getRigths();              
              this.editRights = this.rights;
            }
      }
      }


  }

  private getDismissReason(reason: any): string {
    this.getRigths();
      if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
      } else {
          return `with: ${reason}`;
      }
  }

  public closeModal($event: any) {
    // this.isEdit = false;
    this.getRigths();
      this.modalReference.close();
      if ($event) {
        //  this.changingValue.next($event);
      }
  }

  
  closeModel() {
    let doneObj = {
      action: 'Done',
      obj: null
    }
    this.mdlRef.close(doneObj);
    // this.activeModal.dismiss();
  }


   // addStage() - add new unit
   addStage(stage: string, obj: any){
    debugger
    var temp: any = []
    if(stage == ''){
      alert("Please enter stage name.")
      return;
    }
    for(let i = 0; i < obj.length; i++){
      if(obj[i].isChecked == true){
        let temp = {
            UserID : obj[i].UserID,
            Name: obj[i].Name
        }
        this.UIDs.push(temp)
      }
    }
    let flag = false;
    temp = {
        SID:this.Stages.length + 1,
        SNm:stage,
        Seq: this.Stages.length + 1,
        UIDs:this.UIDs,
        TID: this.prTypeID == 2 ? 2 : 1,
      }
    for (let i = 0; i < this.Stages.length; i++) {
      if(stage.toUpperCase() == this.Stages[i].SNm.toUpperCase()){
        flag = true
        break
      }
    }
    
    if(!flag){
      this.Stages.push(temp);
      this.newStage.stageName = ""
      this.save()
      this.modalReference.close();
    }
    else
    {
      alert("This stage already exists.")
      this.newStage.stageName = ""
      return;
    }

    this.UIDs = []
  }
  
  //editStore() - edit store
  editStage(name: any , obj: any){
    let oldName = this.stage
    let ind = this.editStageId
    var StageData = this.Stages.filter(function (element: any, index: any) {
      return (element.SID == ind);
  });
    let Right : any = []
    for(let i = 0; i < obj.length; i++){
      if(obj[i].isChecked == true){
        let temp = {
          UserID : obj[i].UserID,
          Name: obj[i].Name,
          //isChecked:obj[i].isChecked,
        }
        Right.push(temp);
      }
    }
    let tempStore ={
      'SID': StageData[0].SID,
      'SNm': name,
      'Seq': StageData[0].Seq,
      'UIDs':Right
    }
    let flag = false
    if(name == ''){
      flag = true
      this.stage = oldName;
      alert("Please enter stage name.")
      return
    }
    for (let i = 0; i < this.Stages.length; i++) {
      if(name == this.Stages[i].SNm){
        flag = true
        break
      }
    }
    if(oldName.toUpperCase() == StageData[0].SNm.toUpperCase()){
      flag = false
    }
  
    if(!flag){
      for(let i = 0; i < this.Stages.length; i++){
        if(this.Stages[i].SID == StageData[0].SID){
          this.Stages[i].SNm = tempStore.SNm;
          this.Stages[i].Seq = tempStore.Seq;
          this.Stages[i].UIDs = Right;
        }
      }
      this.save();
      this.modalReference.close();
    }
    else{
      this.stage = StageData[0].sNm
      alert("Please enter valid stage name.")
    }

}

   //save() - save store
   save(){
    let TempStages = [];
      for(let i = 0; i < this.Stages.length; i++){
        let newId = [];
        if(this.Stages[i].UIDs.length != 0){
          for(let j = 0; j < this.Stages[i].UIDs.length; j++){
            newId.push(this.Stages[i].UIDs[j].UserID)
          }
          
        }
        TempStages.push({
          'SID': this.Stages[i].SID,
          'SNm': this.Stages[i].SNm,
          'Seq': this.Stages[i].Seq,
          'UIDs': this.Stages[i].UIDs.length == 0 ? '' : newId.join(","),
          'TID': this.Stages[i].TID //this.prTypeID == 1 ? 1 : 2,
      });
      }
      var tempData = [{
        'ChangeType': 'PRDSTGS',
        'GSTLdgrs':'',
        'Units': '',
        'Stores':'',
        'ItemCategories': '',
        'PrdJobStages': JSON.stringify(TempStages),
        'ValnMethod':1,
        'PrdRejnReasons': '',
        'HSNSAC' : ''
       
      }]
      let myParams = [{
          myUserID: this.jarvisData[0].UserID,
          myToken: this.jarvisData[0].WebToken,
          forAgencyID: this.jarvisData[0].AgencyIDs,
          myAgencyIDs: this.jarvisData[0].AgencyIDs,
          ForERPAgencyID: this.agencyData[0].ERPAgencyID,
          myLastSyncDT: null,
          isWeb: true,
          actionType: 'set',
          moduleID: 6,
          data: JSON.stringify(tempData)
      }];
      this.apiService.sendChange(myParams, this.successEntry.bind(this), this.failureResp.bind(this));
      }
  
   //successVchrEntry - success voucher entry handler
   successEntry(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var ErpData = JSON.parse(res.updatePackage);
          if (ErpData.Table1) {
            let coockieData = [];
            coockieData.push(ErpData.Table1[0]);
            let ErpAgn = JSON.stringify(coockieData);
            localStorage.setItem("ERP_Agn", ErpAgn)
          }
          if (ErpData.Table2) {
            let cookieData2 = [];
            cookieData2.push(ErpData.Table2[0]);
            let ErpCfgData = JSON.stringify(cookieData2);
            localStorage.setItem("ERP_Cfg", ErpCfgData)
          }
    }
        this.Stages = [];
        this.getStage();      
        this.modalReference.close();
    }
}

//failureResp - failure handler
failureResponse(res: any) {
  if (res.error) {
  }
}

//   backBtn() {
//   window.history.back();
// }
backBtn() {
  let urlCheck: string = "";
  if (this.apiService.fn_isLiveURL() == true) {
    urlCheck = "/ERP"
  }
  if(this.prTypeID == 1){
    urlCheck += "/ProductionList?p=1"
  }
  else{
    urlCheck += "/Projects?p=2"
  }
  window.open(urlCheck, "_self");
}

// change color
changeColor(ind: any){
  var clr = ""
  switch(ind) { 

    case 0: { 
      clr = 'orangeBadge'
       break; 
    } 
    case 1: {
      clr = 'yellowBadge'
      break; 
    } 
    case 2: { 
      clr = 'greenBadge'
       break; 
    } 
    case 3: { 
      clr = 'tealBadge'
       break; 
    } 
    case 4: { 
      clr = 'blueBadge'
       break; 
    } 
    case 5: { 
      clr = 'darkBlueBadge'
       break; 
    } 
    case 6: { 
      clr = 'brownBadge'
       break; 
    } 
  
 }
 return clr; 
}

}
